export default __webpack_public_path__ + "static/media/trash-can-bottom.01985ac1.png";